import { isEmpty } from 'lodash-es';
import { mapActions, mapGetters, mapState } from 'vuex';
import Store from '@phoenix/components/Store';
import { FEATURE_FLAG, getFeatureFlag } from '@phoenix/helpers/feature-flag-helper';

export default {
  props: {
    allStoresUrl: {
      type: String,
      default: '',
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    stores: {
      type: Array,
      required: true,
    },
    center: {
      type: Object,
      default: () => ({}),
    },
    zoom: {
      type: Number,
      default: 5,
    },
    shouldLoadStoresOnBoundsChanged: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      mapInitialized: false,
    };
  },

  computed: {
    ...mapState('storeSearch', ['position', 'allStores', 'boundsChanged']),

    ...mapGetters('storeSearch', ['customBounds', 'hasResults', 'searchPerformed']),

    id() {
      return `store-locator-${this.isMobile ? 'mobile' : 'desktop'}`;
    },

    engine() {
      return getFeatureFlag(FEATURE_FLAG.BAIDU) ? 'baidu' : 'google';
    },

    hasCustomBounds() {
      return !isEmpty(this.customBounds);
    },

    getStores() {
      const stores = this.stores.length ? this.stores : this.allStores;

      return stores.map((store) => {
        const status = new Store(
          store.openingHours,
          store.specialDays,
          store.timezone,
          store.isOnline,
          store.id,
        ).getStatusLabel();

        return { ...store, status };
      });
    },

    fitBounds() {
      return this.hasCustomBounds || !this.hasResults || this.boundsChanged ? null : 'auto';
    },

    region() {
      const currentCountry = window.Phoenix.currentCountry;
      return currentCountry !== 'INT' ? currentCountry : 'US';
    },

    apiKey() {
      return this.engine === 'baidu'
        ? window.Phoenix.config.BAIDU_MAPS_API_KEY
        : window.Phoenix.config.GOOGLE_MAPS_API_KEY;
    },

    mapId() {
      return this.engine === 'google' ? window.Phoenix.config.GOOGLE_MAPS_API_MAP_ID : '';
    },
  },

  watch: {
    stores: {
      handler(value) {
        if (this.mapInitialized && !this.boundsChanged) {
          this.$nextTick(() => {
            const mapComponent = this.$refs.storeLocator.getMapComponent();
            mapComponent.fitMapToLocations(this.hasCustomBounds ? this.customBounds : value);
          });
        }
      },
    },
  },

  methods: {
    ...mapActions('storeSearch', ['loadStoresOnBoundsChanged']),

    addTrackingInformation(event) {
      window.dataLayer.push(event); // TODO-tracking
    },

    onMapInitialized() {
      const mapComponent = this.$refs.storeLocator.getMapComponent();
      if (this.hasCustomBounds) {
        mapComponent.fitMapToLocations(this.customBounds);
      } else if (this.hasResults && !this.searchPerformed) {
        mapComponent.fitMapToLocations(this.getStores);
      }
      this.mapInitialized = true;
    },

    onMapBoundsChanged(bounds) {
      if (this.mapInitialized && this.shouldLoadStoresOnBoundsChanged) {
        this.loadStoresOnBoundsChanged(bounds);
      }
    },
  },
};
